import { useEffect, useState } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import "./App.scss";
import Header from "./components/Header/Header";
import LandingPage from "./pages/LandingPage/LandingPage";
import axios from "axios";
import { BASE_URL } from "./api/api";
import Footer from "./components/Footer/Footer";
import SchedulePage from "./pages/SchedulePage/SchedulePage";
import ScrollToTop from "./ScrollToTop";
import KeywordDashboard from "./pages/KeywordDashboard/KeywordDashboard";
import SubredditDashboard from "./pages/SubredditDashboard/SubredditDashboard";
import classnames from "classnames";

const App = () => {
  const [userData, setUserData] = useState({
    username: null,
    icon_img: null,
    scheduled: [],
    access: null,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [timeInterval, setTimeInterval] = useState("1 Month");
  const [postsAnalyzed, setPostsAnalyzed] = useState("500 posts");
  const [analysis, setAnalysis] = useState(false);
  const [subreddits, setSubreddits] = useState([]);

  const history = useHistory();

  const retrieveSessionId = async () => {
    if (!window.sessionStorage.getItem("sid")) {
      try {
        const response = await axios.get(`${BASE_URL}/sid`);
        window.sessionStorage.setItem("sid", response.data.sid);
      } catch (error) {
        console.log("GET sessionId error", error);
      }
    }
  };

  const logoutHandler = async () => {
    try {
      await axios.get(`${BASE_URL}/auth/logout`, {
        withCredentials: true,
      });

      setUserData({
        username: null,
        icon_img: null,
        scheduled: [],
        access: null,
      });

      window.sessionStorage.removeItem("_s");
      history.push("/");
    } catch (error) {
      console.log("logoutHandler error", error);
    }
  };

  const getTopSubreddits = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/reddit/top`);
      setSubreddits(res.data);
    } catch (err) {
      console.log("getTopReddits error", err);
    }
  };

  useEffect(() => {
    getTopSubreddits();
  }, []);

  useEffect(() => {
    const getUserData = async () => {
      try {
        const instance = axios.create({ withCredentials: true });
        const data = await instance.get(`${BASE_URL}/user`, {
          headers: {
            Authorization: `Bearer ${userData.access}`,
          },
        });

        setUserData({
          ...userData,
          username: data.data.username,
          icon_img: data.data.icon_img,
          scheduled: data.data.scheduled,
        });
      } catch (error) {
        if (error.response.status === 403) {
          // access token has expired and we need to renew it
          try {
            const instance = axios.create({ withCredentials: true });
            const data = await instance.get(`${BASE_URL}/auth/refresh`, {
              headers: {
                Authorization: `Bearer ${userData.accessToken}`,
              },
            });

            setUserData({ ...userData, access: data.data.accessToken });
            return;
          } catch (error) {
            console.log("Get new access token error", error);
            return;
          }
        }
      }
    };
    if (!userData.username && window.sessionStorage.getItem("_s")) {
      getUserData();
    }
  }, [userData]);

  useEffect(() => {
    retrieveSessionId();
  }, [searchTerm]);

  return (
    <div className="App">
      <div className={classnames("wrapper", window.location.pathname.includes("subreddit-analysis") && "wrapper__subreddit--gray-bg")}>
        <Header
          userData={userData}
          analysis={analysis}
          logoutHandler={logoutHandler}
          setUserData={setUserData}
          timeInterval={timeInterval}
          setTimeInterval={setTimeInterval}
          postsAnalyzed={postsAnalyzed}
          setPostsAnalyzed={setPostsAnalyzed}
          setSearchTerm={setSearchTerm}
          subreddits={subreddits}
        />
        <ScrollToTop />
        <Switch>
          <Route
            exact
            path="/"
            render={() => (
              <LandingPage
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                timeInterval={timeInterval}
                setTimeInterval={setTimeInterval}
                setAnalysis={setAnalysis}
                postsAnalyzed={postsAnalyzed}
                setPostsAnalyzed={setPostsAnalyzed}
                analysis={analysis}
                subreddits={subreddits}
              />
            )}
          />
          <Route
            path="/subreddit-analysis"
            render={() => (
              <SubredditDashboard
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                timeInterval={timeInterval}
                setAnalysis={setAnalysis}
                userData={userData}
              />
            )}
          />
          <Route
            path="/keyword-analysis"
            render={() => (
              <KeywordDashboard
                timeInterval={timeInterval}
                setTimeInterval={setTimeInterval}
                subreddits={subreddits}
                setAnalysis={setAnalysis}
                postsAnalyzed={postsAnalyzed}
              />
            )}
          />
          <Route
            path="/schedule"
            render={() => (
              <SchedulePage
                analysis={analysis}
                setAnalysis={setAnalysis}
                userData={userData}
                setUserData={setUserData}
              />
            )}
          />
          <Redirect path="*" to="/" />
        </Switch>
      </div>
      <Footer />
    </div>
  );
};

export default App;
